import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Nav from './Nav';
import Footer from '../Footer/Footer';
import "./Layout.scss";

export default function Layout(props) {
  const { iscName, navLinks, setActiveNavLink, isSignWithoutAuth } = props;
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 960 || isSignWithoutAuth) {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    !isSignWithoutAuth ?
      <div>
        <Nav iscName={iscName} expanded={expanded} />
        <Sidebar navLinks={navLinks} setActiveNavLink={setActiveNavLink} expanded={expanded} setExpanded={setExpanded} />
        <div id="advisor-dashboard-container" className={`advisor-container ${expanded ? "sidebar-open" : "sidebar-close closed"}`}>
          {React.Children.map(props.children, child =>
            React.cloneElement(child, { navLinks, setActiveNavLink })
          )}
        </div>
        <Footer expanded={expanded} />
      </div> :
      <div>
        <Nav iscName={iscName} expanded={expanded} isSignWithoutAuth={isSignWithoutAuth} />
        <div id="advisor-dashboard-container" className='container'>
          {React.Children.map(props.children, child =>
            React.cloneElement(child, { navLinks, setActiveNavLink })
          )}
        </div>
        <Footer expanded={expanded} isSignWithoutAuth={isSignWithoutAuth} />
      </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js